<template>
  <div
    class="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 z-30 flex justify-around items-center h-16 shadow-lg overflow-x-auto"
  >
    <router-link
      v-for="item in menuItems"
      :key="item.id"
      :to="item.path"
      class="flex flex-col items-center justify-center text-gray-600 hover:text-blue-500 transition-colors min-w-[72px] flex-shrink-0 relative"
      active-class="text-blue-500"
    >
      <!-- Skeleton loader shown while image is loading -->
      <BaseSkeleton
        v-if="!loadedImages[item.id]"
        width="40px"
        height="40px"
        shape="circle"
        class="absolute"
      />
      
      <!-- Actual image -->
      <img 
        :src="item.icon" 
        class="w-8 h-8"
        :class="{ 'opacity-0': !loadedImages[item.id] }"
        alt="Icon"
        @load="handleImageLoad(item.id)"
        @error="handleImageError(item.id)"
      />
    </router-link>
  </div>
</template>

<script setup>
import { useRightPanelStore } from "@/stores/layoutStore";
import { onMounted, ref, watch } from "vue";
import { useNavigationMenu } from "@/composables/useNavigationMenu";

const rightPanelStore = useRightPanelStore();

// Track loaded images
const loadedImages = ref({});

// Use navigation menu composable
const { menuItems } = useNavigationMenu(rightPanelStore);

// Reset loaded images when menu items change
watch(menuItems, (newItems) => {
  const newLoadedState = {};
  newItems.forEach(item => {
    newLoadedState[item.id] = loadedImages.value[item.id] || false;
  });
  loadedImages.value = newLoadedState;
}, { immediate: true });

const handleImageLoad = (id) => {
  loadedImages.value[id] = true;
};

const handleImageError = (id) => {
  // Mark as loaded even on error to hide skeleton
  loadedImages.value[id] = true;
  console.warn(`Failed to load icon for: ${id}`);
};
</script>